import { useState, useEffect } from 'react';

const useDate = () => {
    const locale = 'en';
    const [today, setDate] = useState(new Date()); // Save the current date to be able to trigger an update

    useEffect(() => {
            const timer = setInterval(() => {
            setDate(new Date());
        }, 1000);
        return () => {
            clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
        }
    }, []);

    const date = today;

    const hour = today.getHours();
    const wish = `Tere ${(hour < 12 && 'hommikust') || (hour < 17 && 'päevast') || 'õhtust'}!`;

    return {
        date,
        wish,
    };
};

export default useDate;